import Axios from "axios";

export interface User {
  id: number;
  roles: string[];
  username: string;
}

const USER_FIELDS = ["id", "roles", "username"].join(",");

const client = Axios.create({
  baseURL: `${process.env.REACT_APP_API_ORIGIN}/2017-06-30`,
});

const getUser = async (userId: number) =>
  (
    await client.get<User>(`/users/${userId}`, {
      params: {
        fields: USER_FIELDS,
      },
      withCredentials: true,
    })
  ).data;

export const apiV2 = {
  getUser,
};
